import { markSeen, reset } from './actions';
import { createReducer } from 'app/api/redux-util/general-helpers';
import moment from 'moment';
import { isDevOrLocal } from 'app/utils/env';
import { createSuccessAction } from 'app/api/redux-util/async-helpers';
import { GET_USER_INFO } from 'app/api/redux-jigsaw/jigsaw-methods';
import { hash } from 'app/utils/strings';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

function getExpiration() {
  if (isDevOrLocal()) {
    return moment()
      .add(4, 'days')
      .format();
  }
  return null;
}

const handlers = {
  [createSuccessAction(GET_USER_INFO).type]: (state, action) => {
    const hashVal = hash(action.data.user.email);
    return {
      ...state,
      active: hashVal,
    };
  },
  [markSeen().type]: (state, action) => {
    return {
      ...state,
      [state.active]: {
        expires: getExpiration(),
        ...state[state.active],
        [action.id]: {
          seen: true,
        },
      },
    };
  },
  [reset().type]: state => ({
    ...state,
    [state.active]: {},
  }),
};

const persistConfig = {
  key: 'onboarding',
  storage,
  blacklist: ['active'],
};

const reducer = createReducer({}, handlers);

export default persistReducer(persistConfig, reducer);

export const testReducer = reducer;
